export default {
  methods: {
    scrollToTop () {
      this.$scrollTo('html', 500)
    }
  }
}
